import { render } from "./RemoveUserForm.vue?vue&type=template&id=75163f72&scoped=true"
import script from "./RemoveUserForm.vue?vue&type=script&lang=js"
export * from "./RemoveUserForm.vue?vue&type=script&lang=js"

import "./RemoveUserForm.vue?vue&type=style&index=0&id=75163f72&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75163f72"]])

export default __exports__